module.exports = __webpack_public_path__ + "img/freezeLevel.ac1f2eec.png";